import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, ReplaySubject, BehaviorSubject } from 'rxjs';
import { User } from '../admin/1.tv/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class StripeResponseService {
  public messageLoginPlus = new Subject<any>();
  public returnMessageLoginPlus = new Subject<any>();

  public messageLogoutPlus = new Subject<any>();
  public returnMessageLogoutPlus = new Subject<any>();

  public currentLoggedInUser: any;
  public companyId: string;
  public siteId: string;

  constructor() { }

  public post(response: any) {
    console.log('post called'.concat(JSON.stringify(response)));

    const o = Object.assign({}, {
      time: new Date(),
      response
    });

    this.messageLoginPlus.next(o);
  }

  setLoginReturnMessage(userData: any) {
    const o = Object.assign({}, {
      time: new Date(),
      userData
    });
    this.currentLoggedInUser = userData;
    console.log('kjb setLoginReturnMessage this.currentLoggedInUser', this.currentLoggedInUser);
    this.returnMessageLoginPlus.next(o);
  }

  setLoginMessage(userData: any) {

    const o = Object.assign({}, {
      time: new Date(),
      userData
    });

    this.currentLoggedInUser = userData;
    console.log('kjb setLoginMessage this.currentLoggedInUser', this.currentLoggedInUser);
    this.messageLoginPlus.next(o);
  }

  setLogoutReturnMessage(userData: any) {
    const o = Object.assign({}, {
      time: new Date(),
      userData
    });
    this.currentLoggedInUser = null;
    this.returnMessageLogoutPlus.next(o);
  }

  setLogoutMessage(userData: any) {

    const o = Object.assign({}, {
      time: new Date(),
      userData
    });
    this.currentLoggedInUser = null;
    this.messageLogoutPlus.next(o);
  }
}
